import React from "react";
import { useIntl } from "react-intl";
import { useMatch, useNavigate } from "react-router-dom";
import { useForgotPasswordDialog } from "context/ForgotPasswordDialog";
import { Dialog, DialogDescription, DialogTitle } from "components/ui/dialog";
import { DialogCard } from "components/ui/dialog-card";
import { ROUTES } from "routes";
import ForgotPasswordForm from "./ForgotPasswordForm";

const ForgotPasswordDialog: React.FC = () => {
    const { state: { open }, actions: { closeForgotPassword } } = useForgotPasswordDialog();
    const intl = useIntl();
    const navigate = useNavigate();
    const isForgotPasswordRoute = useMatch(ROUTES.FORGOT_PASSWORD);
    const isOpen = open || !!isForgotPasswordRoute;

    const handleOpenChange = (nextOpen: boolean) => {
        if (!nextOpen) {
            closeForgotPassword();
            if (isForgotPasswordRoute) navigate(ROUTES.HOME, { replace: true });
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={handleOpenChange}>
            <DialogCard closeLabel={intl.formatMessage({ id: "authentication.profile_choice.close" })}>
                <div className="flex flex-col">
                    <DialogTitle className="font-nunito text-3xl font-black leading-12 text-gray-900">
                        {intl.formatMessage({ id: "authentication.forgot_password.dialog.title" })}
                    </DialogTitle>
                    <DialogDescription className="font-nunito text-base font-medium leading-6 text-slate-600">
                        {intl.formatMessage({ id: "authentication.forgot_password.dialog.description" })}
                    </DialogDescription>
                </div>
                <ForgotPasswordForm open={isOpen} />
            </DialogCard>
        </Dialog>
    );
};

export default ForgotPasswordDialog;
